export default "__VITE_ASSET__zrxEybWp__"